import React, { useEffect, useState } from "react";
import Modal from "react-animated-modal";
import CustomScroll from "react-custom-scroll";
import AnnouncementItem from "./AnnouncementItem";

function AnnouncementsModal(props) {
  return (
    <Modal visible={true} type="fadeIn" closemodal={props.openCloseModal}>
      <div className="modal" role="dialog">
        <div className="announcement-modal">
          <div className="modal" tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div
                  className={
                    "modal-header-" + props.mostImportantAnnouncementType
                  }
                >
                  <div className="announcement-title">
                    {props._.Announcements}
                    <button className="btn">
                      <i
                        className="icon-omni-close-circle"
                        onClick={props.openCloseModal}
                      />
                    </button>
                  </div>
                </div>
                <CustomScroll
                  heightRelativeToParent="50%"
                  allowOuterScroll={false}
                >
                  <div className="modal-body">
                    {props.announcements.map((a) => (
                      <AnnouncementItem
                        key={a.id}
                        announcement={a}
                        _={props._}
                      />
                    ))}
                  </div>
                </CustomScroll>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default AnnouncementsModal;
